import { c as _c } from "react/compiler-runtime";
import { VStack, Heading, Button, Stack, AspectRatio, Image, Box, Text, Badge } from '@chakra-ui/react';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import React from 'react';
type ArticleHeroCardProps = {
  articleType?: string;
  termSlugs?: string[];
  typeSlug?: string;
  terms?: string;
  featuredImage?: string;
  title?: string;
  slug?: string;
  subjectNames?: string[];
  subjectLogos?: string;
};
export const ArticleHeroCard = props => {
  const $ = _c(64);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([10, 10, 10, 20]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([10, 10, 10, 20]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue([10, 10, 10, 20]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `linear-gradient(180deg, #1A1B2090, #1A1B20), url(${props.featuredImage}) center center/cover no-repeat`;
  const t4 = `linear-gradient(180deg, #1A1B2090, #1A1B20), url(${props.featuredImage}) center center/cover no-repeat`;
  let t5;
  if ($[6] !== getBreakpointValue || $[7] !== t3 || $[8] !== t4) {
    t5 = getBreakpointValue([t3, t4, "transparent"]);
    $[6] = getBreakpointValue;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== getBreakpointValue) {
    t6 = getBreakpointValue(["center", "center", "space-between"]);
    $[10] = getBreakpointValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props.articleType || $[13] !== props.terms) {
    t7 = props.articleType === "ExpertAdvice" && <Badge size="sm" variant="subtle">{props.terms || "Featured"}</Badge>;
    $[12] = props.articleType;
    $[13] = props.terms;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== getBreakpointValue || $[16] !== props.articleType || $[17] !== props.subjectLogos) {
    t8 = props.articleType === "FounderStory" && <Box h="auto" overflow="hidden" position="relative" width={getBreakpointValue(["6em", "6em", "10em"])}><Image filter={{
        _light: "invert(1)",
        _dark: "invert(0)"
      }} h="100%" objectFit="contain" src={props.subjectLogos} w="100%" /></Box>;
    $[15] = getBreakpointValue;
    $[16] = props.articleType;
    $[17] = props.subjectLogos;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== getBreakpointValue) {
    t9 = getBreakpointValue(["center", "center", "flex-start"]);
    $[19] = getBreakpointValue;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = `/${props.typeSlug || "articles"}/${props.slug}`;
  let t11;
  if ($[21] !== getBreakpointValue) {
    t11 = getBreakpointValue(["3xl", "3xl", "3xl", "4xl", "5xl"]);
    $[21] = getBreakpointValue;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = props.title || "Loading...";
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <Heading as="h1" size={t11}>{t12}</Heading>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = <NextLink href={t10} prefetch={false}>{t13}</NextLink>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== getBreakpointValue || $[30] !== props.subjectNames) {
    t15 = props.subjectNames && props.subjectNames.length > 0 && <Text fontSize={getBreakpointValue(["xl", "xl", "2xl"])}>{"with "}{props.subjectNames.join(", ")}</Text>;
    $[29] = getBreakpointValue;
    $[30] = props.subjectNames;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t9) {
    t16 = <VStack align={t9}>{t14}{t15}</VStack>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== getBreakpointValue) {
    t17 = getBreakpointValue(["md", "md", "md", "lg"]);
    $[36] = getBreakpointValue;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const t18 = props.articleType === "ExpertAdvice" ? `/${props.typeSlug || "articles"}/${props.slug}` : `/${props.typeSlug || "founder-interviews"}/${props.slug}`;
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ChevronRightIcon />;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t18) {
    t20 = <NextLink passHref={true} href={t18}>{" "}Continue{t19}</NextLink>;
    $[39] = t18;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t17 || $[42] !== t20) {
    t21 = <Button asChild={true} colorPalette="actionActiveSecondary" size={t17} variant="solid">{t20}</Button>;
    $[41] = t17;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t16 || $[45] !== t21 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8) {
    t22 = <VStack align="flex-start" flex={1} gap={10} justify={t6} zIndex={2}>{t7}{t8}{t16}{t21}</VStack>;
    $[44] = t16;
    $[45] = t21;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== getBreakpointValue) {
    t23 = getBreakpointValue([true, true, false]);
    $[50] = getBreakpointValue;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== props.featuredImage) {
    t24 = <Image src={props.featuredImage} />;
    $[52] = props.featuredImage;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = <AspectRatio borderRadius="2xl" flex={2} hidden={t23} overflow="hidden" ratio={1.7777777777777777}>{t24}</AspectRatio>;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t0 || $[58] !== t1 || $[59] !== t2 || $[60] !== t22 || $[61] !== t25 || $[62] !== t5) {
    t26 = <Stack direction="row" gap={t0} height="full" justify="center" paddingBottom={5} paddingTop={t1} paddingX={t2} position="relative" background={t5}>{t22}{t25}</Stack>;
    $[57] = t0;
    $[58] = t1;
    $[59] = t2;
    $[60] = t22;
    $[61] = t25;
    $[62] = t5;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  return t26;
};